import { yupEnum, yupObject, yupString } from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export const RATING_REPORT_REASONS = [
  'NON_PAYMENT',
  'OTHER',
  'RATING',
] as const;

export const REPORT_REASONS = [
  'DOUBLE_BROKERING',
  'IDENTITY_THEFT',
  'UNAUTHORIZED_DISPATCHING',
  'SUSPICIOUS_ACTIVITY',
] as const;

export type ExtendedReason =
  | (typeof REPORT_REASONS)[number]
  | (typeof RATING_REPORT_REASONS)[number];

export type ShipperReportDTO = InferType<typeof shipperReportSchema>;
export const shipperReportSchema = yupObject({
  reason: yupEnum(REPORT_REASONS, null).required(),
  contact: yupString()
    .ensure()
    .required('Enter your preferred email address or phone number ')
    .trim()
    .max(200),
  description: yupString()
    .ensure()
    .required('Enter a description')
    .trim()
    .max(5000),
  shipper_name: yupString(),
});

export function isRatingReportReason(reason: string): boolean {
  return (RATING_REPORT_REASONS as readonly string[]).includes(reason);
}
